import { EMPTY_TIMESTAMP } from '@app/core/models/constants/app.constants';

export function timestampHasNotRun(timestamp: string): boolean {
    return timestamp === EMPTY_TIMESTAMP;
}
